export const phoneRegExp = /^(?:[0-9] ?){6,14}[0-9]$/;
